import { render } from "./EventCard.vue?vue&type=template&id=34c98c10&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=34c98c10&scoped=true&lang=css"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/hbhotel-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c98c10"]])

export default __exports__